const newSvg = `
<svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_466_9)">
    <path d="M9.09017 14.275L4.94017 16.775C4.75684 16.8916 4.56517 16.9416 4.36517 16.9249C4.16517 16.9083 3.99017 16.8416 3.84017 16.725C3.69017 16.6083 3.57351 16.4626 3.49017 16.288C3.40684 16.1133 3.39017 15.9173 3.44017 15.7L4.54017 10.975L0.865173 7.79995C0.698506 7.64995 0.594506 7.47895 0.553173 7.28695C0.511839 7.09495 0.524173 6.90762 0.590173 6.72495C0.656173 6.54228 0.756173 6.39228 0.890173 6.27495C1.02417 6.15762 1.20751 6.08262 1.44017 6.04995L6.29017 5.62495L8.16517 1.17495C8.24851 0.974951 8.37784 0.824951 8.55317 0.724951C8.72851 0.624951 8.90751 0.574951 9.09017 0.574951C9.27284 0.574951 9.45184 0.624951 9.62717 0.724951C9.80251 0.824951 9.93184 0.974951 10.0152 1.17495L11.8902 5.62495L16.7402 6.04995C16.9735 6.08328 17.1568 6.15828 17.2902 6.27495C17.4235 6.39162 17.5235 6.54162 17.5902 6.72495C17.6568 6.90829 17.6695 7.09595 17.6282 7.28795C17.5868 7.47995 17.4825 7.65062 17.3152 7.79995L13.6402 10.975L14.7402 15.7C14.7902 15.9166 14.7735 16.1126 14.6902 16.288C14.6068 16.4633 14.4902 16.609 14.3402 16.725C14.1902 16.841 14.0152 16.9076 13.8152 16.9249C13.6152 16.9423 13.4235 16.8923 13.2402 16.775L9.09017 14.275Z" fill="#F1B434"></path>
  </g>
  <defs>
    <clipPath id="clip0_466_9">
      <rect width="18" height="17" fill="white"></rect>
    </clipPath>
  </defs>
</svg>
`;

function waitForElements() {
  const ratingStars = document.querySelectorAll('.c-home-product__rating__star');
  const ratingStarsBackground = document.querySelectorAll('.c-home-product__rating__star--background');

  if (ratingStars.length > 0 && ratingStarsBackground.length > 0) {
    ratingStars.forEach((star) => {
      const svgs = star.querySelectorAll('svg');
      svgs.forEach((svg) => {
        svg.outerHTML = newSvg;  
      });
    });

    ratingStarsBackground.forEach((starBackground) => {
      const svgs = starBackground.querySelectorAll('svg');
      svgs.forEach((svg) => {
        svg.outerHTML = newSvg;  
      });
    });

    clearInterval(interval);
    console.log('SVGs have been replaced.');
  }
}

const interval = setInterval(waitForElements, 100); 

